import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';
import { selectPaymentFees, selectPaymentSuccessInfo, selectSelectedPaymentMethod } from '../../../../store/slices/payment/paymentSelectors';
import { PAYMENT_METHODS } from '../../constants';
import { calculateTotalDue } from '../utils';
import { convertNumberToCurrency } from '../../../../common/utils';
import { Grid, Row, Col, Text } from 'rsuite';
import { selectConfigTaxCheckMailingAddress, selectConfigTaxCheckPayTo } from '../../../../store/slices/config/configSelectors';

const CheckSuccess = () => {
    const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
    const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);
    const paymentFees = useSelector(selectPaymentFees);
    const checkMailingAddress = useSelector(selectConfigTaxCheckMailingAddress);
    const checkPayTo = useSelector(selectConfigTaxCheckPayTo);

    const totalDue = useMemo(() => calculateTotalDue(selectedPaymentMethod, paymentFees), [selectedPaymentMethod, paymentFees]);

    return (
        selectedPaymentMethod === PAYMENT_METHODS.CHECK && (
            <Grid fluid>
                <Row className='mb-8'>
                    <Col xs={24}>
                        <Text className='text-bold'>Check Details:</Text>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24}>
                        <ul className='check-details-list'>
                            <li>
                                <Text className='text-small'>Your unique code is <span className='text-bold'>{paymentSuccessInfo?.paymentStatusDetails?.checkUniqueCode}</span>, please ensure this is written on the back of your check.</Text>
                            </li>
                            <li>
                                <Text className='text-small'>Please ensure the exact amount of <span className='text-bold'>{convertNumberToCurrency(totalDue)}</span> is written in the check.</Text>
                            </li>
                            <li>
                                <Text className='text-small'>Please ensure the check is made out to <span className='text-bold'>{checkPayTo}</span> and mailed to <span className='text-bold'>{checkMailingAddress}</span>.</Text>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Grid>
        )
    )
}

export default CheckSuccess
